export const PRODUCT_APPLICATION_STATE_CONSTANT = {
  RET_RP: {
    ON_PROCESS: 'ON_PROCESS_RAPIPLAZO',
    DECLINED: 'DECLINED_RAPIPLAZO',
    CANCELED: 'CANCELED_RAPIPLAZO',
  },
};
